import * as Yup from 'yup'

const brandExclusionCommentSchema = Yup.object().shape({
  exclusionComment: Yup.string()
    .required('Exclusion comment is required')
    .nullable(),
})

export default brandExclusionCommentSchema
